import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

const cardVariants = cva(
  "border transition-[transform,border-color,box-shadow,background-color] duration-300 ease-out motion-safe:hover:-translate-y-1 motion-safe:hover:border-accent/45 motion-safe:hover:shadow-[0_28px_60px_-36px_hsl(var(--shadow-strength)/0.38)]",
  {
    variants: {
      variant: {
        aside: "border-border/70 bg-[hsl(var(--surface-muted))] p-5 sm:p-6",
        content: "border-border/70 bg-[hsl(var(--surface))] p-5 sm:p-6 md:p-7",
        feature: "border-border/70 bg-[hsl(var(--surface))] p-5 sm:p-6",
        form: "border-border/70 bg-[hsl(var(--surface))] p-5 sm:p-6 md:p-7",
        stat: "border-border/70 bg-[hsl(var(--surface))] p-5 md:p-6",
      },
    },
    defaultVariants: {
      variant: "content",
    },
  },
);

export interface CardProps
  extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof cardVariants> {}

export function Card({ className, variant, ...props }: CardProps): JSX.Element {
  return (
    <div className={cn(cardVariants({ className, variant }))} {...props} />
  );
}
